import React, { useState, useEffect, forwardRef, Ref, useRef } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axios from 'axios';
import { BASEURL } from "../../constants/Common";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './calendarstyles.css';
import logo from '../../assets/logo/brix logo1.png';
import { Button } from '@mui/material';

const localizer = momentLocalizer(moment);

interface TasksEvent {
    id: number;
    title: string;
    start: Date;
    end: Date;
    projectId: string; // Add projectId to track project color
    color: string;
}

interface ProjectWeeklyTasksProps {
    project_ids: string;  // list of projects ids separated by comma
    orgid: string | null;
    projectname:string[];
    projectcode:string[];
}

const ProjectGanttCalendar = forwardRef<HTMLDivElement, ProjectWeeklyTasksProps>(
    ({ project_ids, orgid,projectname,projectcode }, ref: Ref<HTMLDivElement>) => {
        const [taskDetails, setTaskDetails] = useState<TasksEvent[]>([]); // Initialize as empty array
        const [projectColors, setProjectColors] = useState<{ [key: string]: string }>({}); // Store colors for each project
        const calendarRef = useRef<HTMLDivElement | null>(null);

        useEffect(() => {
            fetchTaskDetails();
        }, [project_ids]);

        const fetchTaskDetails = async () => {
            try {
                const status_url = `${BASEURL}/projects/activities?projectids=${project_ids}&orgid=${orgid}`;
                const response = await axios.get(status_url, {
                    headers: { Accept: 'application/json' },
                });

                const project_tasks: any[] = response.data.activities;
                console.log("project_tasks:",project_tasks);
                const tasks: TasksEvent[] = project_tasks.map((item: any) => ({
                    id: item.id,
                    title: item.project_code + " - " + item.activity_name,
                    start: new Date(item.activity_start_date),
                    end: calculateEndDate(item.activity_start_date, item.activity_duration),
                    projectId: item.project_id, // Track project code for consistent color
                    color: item.color
                }));

                setTaskDetails(tasks);
                // generateColorsForProjects(tasks);
            } catch (error) {
                console.log(error);
            }
        };

        function calculateEndDate(startDate: string, duration: number): Date {
            const startDateObj = new Date(startDate);
            const endDateObj = new Date(startDateObj);
            endDateObj.setDate(startDateObj.getDate() + duration);
            return endDateObj;
        }

        // const generateColor = () => {
        //     const randomColor = () => Math.floor(Math.random() * 256);
        //     return `rgb(${randomColor()}, ${randomColor()}, ${randomColor()})`;
        // };

        // const generateColorsForProjects = (tasks: TasksEvent[]) => {
        //     const colors: { [key: string]: string } = {};
        //     const uniqueProjectIds = Array.from(new Set(tasks.map(task => task.projectId.toString())));

        //     uniqueProjectIds.forEach((projectId) => {
        //         colors[projectId] = generateColor();
        //     });

        //     setProjectColors(colors)
        // };

        const eventPropGetter = (event: TasksEvent) => {
            const color = event.color || '#000'; // Use stored color or fallback
            let style = {
                backgroundColor: color,
                height: 'auto',
                whiteSpace: 'normal',
            };
            return {
                style: style,
            };
        };


    //     const addLogoAndTitle = (doc: jsPDF, titleText: string,taskDetails: TasksEvent[]
    //         ) => {
    //         const docWidth = doc.internal.pageSize.getWidth();
    //         const logoWidth = 36; // Adjust size as needed
    //         const logoHeight = 15; // Adjust size as needed
    //         const margin = 10;

    //         // Add the logo
    //         doc.addImage(logo, 'PNG', 12, 12, logoWidth, logoHeight);

    //         // Calculate the title position
    //         const titleX = (docWidth - doc.getTextWidth(titleText)) / 2;

    //         // Add the title
    //         doc.setFontSize(16);
    //         doc.text(titleText, titleX, 20);

    //            // Extract unique project names and codes from taskDetails
    // const uniqueProjects = Array.from(
    //     new Map(taskDetails.map((task) => [task.projectId, task])).values()
    // );

    // let currentY = 30; // Starting Y position for project details
    // const projectTextX = 12; // Align with the logo
    // // Add each project name and code
    // doc.setFontSize(12);
    // uniqueProjects.forEach((project) => {
    //     console.log("project:",project);
    //     const projectText = `Project Name:${projectname[0]} 
    //      Project Code: ${project.title.split(" - ")[0]}`;
    //     doc.text(projectText, projectTextX, currentY);
    //     currentY += 10; // Move down for the next line
    // });


    //         // Add created date below the logo
    //         const createdDateText = `Date: ${new Date().toLocaleDateString()}`;
            
    //         const createdDateY = 12 + logoHeight + 10; // Position created date below the logo
    //         doc.setFontSize(12);
    //         doc.setFont('Helvetica', 'normal'); // Set font to normal
    //         doc.text(createdDateText, projectTextX, createdDateY); // Add created date

    //         return createdDateY + 20; // Return the Y position for the next content
    //     };

    const addLogoAndTitle = (doc: jsPDF, titleText: string, taskDetails: TasksEvent[]) => {
        const docWidth = doc.internal.pageSize.getWidth();
        const logoWidth = 36; // Adjust size as needed
        const logoHeight = 15; // Adjust size as needed
        const margin = 10;
    
        // Add the logo
        doc.addImage(logo, 'PNG', 12, 12, logoWidth, logoHeight);
    
        // Calculate the title position
        const titleX = (docWidth - doc.getTextWidth(titleText)) / 2;
    
        // Add the title
        doc.setFontSize(16);
        doc.text(titleText, titleX, 20);
    
        // Extract unique project names and codes from taskDetails
        const uniqueProjects = Array.from(
            new Map(taskDetails.map((task) => [task.projectId, task])).values()
        );
    
        let currentY = 12 + logoHeight + 15; // Position below the logo
        const projectTextX = 12; // Align with the logo
    
        // Add each project name and code
        doc.setFontSize(12);
        
            const projectName = `Project Name: ${projectname[0]}`;
            const projectCode = `Project Code: ${projectcode[0]}`;
    
            // Add project name
            doc.text(projectName, projectTextX, currentY);
            currentY += 10; // Space between name and code
    
            // Add project code below the name
            doc.text(projectCode, projectTextX, currentY);
            currentY += 10; // Additional space for the next project
        
    
        // Add created date below the last project details
        const createdDateText = `Date: ${new Date().toLocaleDateString()}`;
        doc.setFontSize(12);
        doc.setFont('Helvetica', 'normal'); // Set font to normal
        doc.text(createdDateText, projectTextX, currentY); // Add created date
    
        return currentY + 10; // Return the Y position for the next content
    };
    

        const calendarExportPDF = () => {
            if (calendarRef.current) {
                html2canvas(calendarRef.current, { scale: 2 }).then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const doc = new jsPDF('landscape', 'mm', 'a4'); // A4 size

                    // Add logo and title
                    const titleText = 'Project Schedule Calendar View';
                    const nextY = addLogoAndTitle(doc, titleText,taskDetails);

                    // Calculate dimensions and scaling
                    const docWidth = doc.internal.pageSize.getWidth();
                    const docHeight = doc.internal.pageSize.getHeight();
                    const canvasWidth = canvas.width;
                    const canvasHeight = canvas.height;
                    const margin = 10; // Margin from the edges

                    // Calculate available width and height for the image
                    const availableWidth = docWidth - 2 * margin;
                    const availableHeight = docHeight - nextY - margin; // Space below project info

                    // Calculate scaling ratio to fit the image within available space
                    const widthRatio = availableWidth / canvasWidth;
                    const heightRatio = availableHeight / canvasHeight;
                    const ratio = Math.min(widthRatio, heightRatio);

                    // Apply the ratio to image dimensions
                    let imgWidth = canvasWidth * ratio;
                    let imgHeight = canvasHeight * ratio;

                    imgWidth *= 1.5;

                    // Reduce image height slightly to prevent overlap
                    imgHeight *= 0.95; // Reduce by 5%

                    // Center the image horizontally
                    const imgX = (docWidth - imgWidth) / 2;

                    // Position the image below the static content
                    let imgY = nextY;

                    // Ensure image does not overlap bottom margin
                    if (imgY + imgHeight > docHeight - margin) {
                        imgY = docHeight - margin - imgHeight;
                    }

                    // Add border around the PDF page
                    doc.setDrawColor(0, 0, 0);
                    doc.setLineWidth(1);
                    doc.rect(margin, margin, docWidth - 2 * margin, docHeight - 2 * margin); // Draw border


                    // Add image to PDF
                    doc.addImage(imgData, 'PNG', imgX, imgY, imgWidth, imgHeight);

                    // Save PDF
                    doc.save(`CalendarView.pdf`);
                }).catch((error) => {
                    console.error('Error exporting calendar to PDF:', error);
                });
            } else {
                console.error('Calendar reference not found.');
            }
        };

        return (
            <div>
                <Button variant="contained" onClick={calendarExportPDF}>Export to PDF</Button>
                <div style={{ height: '180vh', margin: '10px', marginLeft: '-1px' }} ref={calendarRef}>
                    <Calendar
                        localizer={localizer}
                        events={taskDetails}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month', 'week', 'day']}
                        defaultView="month"
                        titleAccessor="title"
                        eventPropGetter={eventPropGetter}
                    />
                </div>
            </div>
        );
    }
);

export default ProjectGanttCalendar; 